import {createAction} from "@ngrx/store";

export const closeNotificationMenu = createAction('[Notifications Center] Close Notification Menu');
